import React, { useEffect, useState } from 'react'
import './Home.css'
import Card from '../Components/Card'
import Image from './assets/loading1.gif'


const COTFutures = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const apikey = process.env.REACT_APP_API_KEY;
  const currentDate = new Date().toLocaleDateString('en-CA');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://financialmodelingprep.com/api/v4/commitment_of_traders_report?from=2020-09-12&to=${currentDate}&apikey=${apikey}`
        );
        const jsonData = await response.json();
        setData(jsonData);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const dataBySector = data.reduce((acc, curr) => {
    const sector = curr.sector;
    if (sector !== "0") {
      if (!acc[sector]) {
        acc[sector] = [];
      }
      acc[sector].push(curr);
    }
    return acc;
  }, {});

  const link = "futures/fin"

  return (
    <div className='p-sm-5 pt-5 pb-5' style={{ backgroundColor: "#e6e6e6" }}>
      <h2 className='text-center fw-bold'>COT Reports and Charts: Financial Futures, Futures Only</h2>
      <div className="cottables p-4 p-sm-4 mt-sm-5">
        {isLoading ? (
          <div><img src={Image} alt="Loading......." /></div>
        ) : (
          <div className='cards'>
            {Object.entries(dataBySector).map(([sector, sectorData]) => (
              <Card key={sector} data={sectorData} sector={sector} link={link} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default COTFutures